import FormTextField from '../../2compounds/FormTextField'
import { Text, TextButton } from '../../1elements'
import makeStyles from '@material-ui/core/styles/makeStyles'
import {
  validateDescription,
  validateRecordName,
  validateRecordURL,
  validateServiceName
} from '../../../services/util/editChecks'
import { useState } from 'react'
import Add from '@mui/icons-material/Add'

const useStyles = makeStyles({
  root: {
  },
  buttonDiv: {
    display: 'flex'
  },
  headingDiv: {
    marginBottom: '20px'
  }
})

const ServiceForm = ({
  selectedServiceType, serviceData, updateServiceData, addNewService, updateSavedService,
  showError, selectedServiceTypeId, disabled
}) => {
  const classes = useStyles()
  const [duplicated, setDuplicated] = useState(false)

  if (!disabled) {
    validateServiceName(serviceData.serviceName, selectedServiceTypeId).then((res) => {
      setDuplicated(res)
    })
  }

  const documentTitle = disabled && serviceData.document_url_name && serviceData.document_url_name[0][0] &&
            Object.keys(serviceData.document_url_name[0][0])[0]
    ? Object.keys(serviceData.document_url_name[0][0])[0]
    : serviceData.attachmentTitle

  const documentLink = disabled && serviceData.document_url_name && serviceData.document_url_name[0][0] &&
            serviceData.document_url_name[0][0][documentTitle]
    ? serviceData.document_url_name[0][0][documentTitle]
    : serviceData.attachmentUrl

  return (
    <div className={classes.root}>
      <div className={classes.headingDiv}>
        <Text type='tabHeadingSecondary'>Create a new service of <span>{selectedServiceType}</span></Text>
      </div>

      {
                !disabled
                  ? (
                    <>
                      <FormTextField
                        label='Service Name' required hint='Max. 100 characters'
                        value={serviceData.serviceName}
                        onChange={(newValue) => updateServiceData('serviceName', newValue)}
                        validation={showError && validateServiceName() && duplicated} disabled={disabled}
                      />
                      <FormTextField
                        label='Description' hint='Max. 255 characters' rows={5}
                        value={serviceData.serviceDescription}
                        onChange={(newValue) => updateServiceData('serviceDescription', newValue)}
                        validation={showError && validateDescription(serviceData.serviceDescription)} disabled={disabled}
                      />
                      <Text>Attachment</Text>
                      <FormTextField
                        label='Title'
                        value={serviceData.attachmentTitle}
                        onChange={(newValue) => updateServiceData('attachmentTitle', newValue)}
                        validation={showError && serviceData.attachmentTitle && validateRecordName(serviceData.attachmentTitle)}
                        disabled={disabled}
                      />
                      <FormTextField
                        label='URL'
                        value={serviceData.attachmentUrl}
                        onChange={(newValue) => updateServiceData('attachmentUrl', newValue)}
                        validation={showError && serviceData.attachmentUrl && validateRecordURL(serviceData.attachmentUrl)}
                        disabled={disabled}
                      />
                    </>
                    )
                  : (
                    <>
                      <FormTextField
                        label='Service Name' required hint='Max. 100 characters'
                        value={serviceData.name ? serviceData.name : serviceData.serviceName}
                        disabled={disabled}
                      />
                      <FormTextField
                        label='Description' hint='Max. 255 characters' rows={5}
                        value={serviceData.description ? serviceData.description : serviceData.serviceDescription}
                        disabled={disabled}
                      />
                      <Text>Attachment</Text>
                      <FormTextField
                        label='Title'
                        value={documentTitle}
                        disabled={disabled}
                      />
                      <FormTextField
                        label='URL'
                        value={documentLink}
                        disabled={disabled}
                      />
                    </>
                    )
            }

      <div className={classes.buttonDiv}>
        {!disabled && (
          serviceData.saved
            ? (<TextButton clickHandler={() => updateSavedService(serviceData.id)}>Update This Service</TextButton>)
            : (<TextButton variant='contained' clickHandler={addNewService}><Add />Add This Service</TextButton>)
        )}
      </div>
    </div>
  )
}

export default ServiceForm
